export class GWInsured {
    public id: number;
    public eventId: number;
    public firstName: string;
    public lastName: string;
    public isPrimary: boolean;
    public dateOfBirth: string;
    public age: number;
    public insurableCost: number;
    public addressLine1: string;
    public addressLine2: string;
    public city: string;
    public stateIso2: string;
    public postalCode: string;
    public countryIso2: string;
    public email: string;
    public phone: string;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/shared/models/agents-gateway/save-quote/gw-insured.model.ts